import React from 'react'

import UserAvatar from '@cinch/oxd-components/user-avatar/src'

import styles from './author.module.css'

interface AuthorImageProps {
  url: string
}

export interface AuthorProps {
  imgSrc?: AuthorImageProps
  givenName: string
  familyName: string
  occupation?: string
  bio?: string
}

const Author: React.FC<AuthorProps> = ({ imgSrc, givenName = '', familyName = '', occupation, bio }) => {
  const name = `${givenName} ${familyName}`

  return (
    <div>
      <div className={styles.top}>
        {imgSrc && <UserAvatar additionalClass={styles.avatar} picture={imgSrc.url} alt={name} isSmall={true} />}
        <div className={styles.info}>
          <div className={styles.authorName}>{name}</div>
          {occupation && <div className={styles.occupation}>{occupation}</div>}
        </div>
      </div>
      {bio && <div className={styles.bio}>{bio}</div>}
    </div>
  )
}

export default Author
